export const ROLES_OPERATEUR_LOCAL_REFERENTIEL_KEY = "ROLES_OPERATEUR";
export const CODES_PACKAGES_LOCAL_REFERENTIEL_KEY = "CODES_PACKAGES";
export const STATUT_TRANSACTION_LOCAL_REFERENTIEL_KEY = "STATUT_TRANSACTION";
export const STATUS_SOUSCRIPTION_LOCAL_REFERENTIEL_KEY = "STATUS_SOUSCRIPTION";
export const EXERCICE_SOUSCRIPTION_LOCAL_REFERENTIEL_KEY =
  "EXERCICE_SOUSCRIPTION";
export const PORT_SOUSCRIPTION_LOCAL_REFERENTIEL_KEY = "PORT_SOUSCRIPTION";
